import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { mooreConfig } from "./data";

export default function MoorePage() {
  return <CityPageTemplate config={mooreConfig} />;
}